// extracted by mini-css-extract-plugin
module.exports = {"mainImageContainer":"HeaderNoteImage_mainImageContainer__al13j","mainImageContainerImg":"HeaderNoteImage_mainImageContainerImg__pGeXN"};